import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")


export const deleteMovement = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "pollination-movements/delete-movement", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};



export const updateQuantities = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "pollination-movements/update-quantities", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};

export const updateLinePalm = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "pollination-movements/update-line-palm", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};


export const removeDuplicates = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "task/remove-duplicates", data, config)
    const responseData = response.data;
    return responseData;
  } catch (error) {
    console.error("Error :", error);
    return null;
  }
};




export const insertManualMovement = async (data) => {
  const config = {
    headers: {
      client: clientId,
      Authorization: `Bearer ${accessToken}`
    }
  };

  try {
    const response = await axios.post(
      URL_BASE + "pollination-movements/insert-manual-movement",
      data,
      config
    );

    return response.data;
  } catch (error) {
    console.error("Error:", error);
    if (error.response) {
      return error.response.data;
    }

    return {
      message: "connection_error",
      status: 500,
      success: false,
      data: null,
      error: error.message
    };
  }
};





export default {
  updateQuantities,
  updateLinePalm,
  deleteMovement,
  removeDuplicates,
  insertManualMovement
};
